import React, { FC, useContext, useEffect, useState } from 'react';

import classNames from 'classnames';

import { Checkbox, Switcher } from '@shared/ui';

import cls from './BodyComponents.module.css';
import { DateInput } from '../../../../../components/DateInput/DateInput';
import { FormBlock } from '../../../../../components/UI/Form/FormBlock/FormBlock';
import { Select } from '../../../../../components/UI/Select/Select';
import { SelectIntegration } from '../../../../../components/UI/SelectIntegration/SelectIntegration';
import { Input } from '../../../../../components/UI/TextInput/Input';
import { Context } from '../../../Accounts';
import { ModalAddContext } from '../ModalAdd';

export const CompanyBlock = () => {
    const { integrationList } = useContext(Context);

    const {
        currentList,
        isActiveCheckbox,
        isActiveSwitcher,
        onSwitcherChange,
        onCheckboxChange,
        formState,
        formHandler,
        onCurrencyChange,
        selectedCurrency,
        legalList,
        onLegalChange,
        selectedLegal,
        onDateChange,
        errors,
        onIntegrationChange,
        selectedIntegration,
        integrationAccountList,
        selectedIntegrationAccount,
        onIntegrationAccountChange,
        sumFormHandler,
    } = useContext(ModalAddContext);

    const { account_number, opening_balance_value, title } = formState;

    useEffect(() => {
        const initialState = {
            title: null,
            accountStartBalance: null,
            currency: null,
            legalEntity: null,
        };
        if (errors.company) {
            errors.company.forEach((error) => {
                initialState[error.name] = error.messages.toString();
            });
        }
        setErrorsTab(initialState);
    }, [errors.company]);

    const [errorsTab, setErrorsTab] = useState({
        title: null,
        accountStartBalance: null,
        currency: null,
        legalEntity: null,
        accountInBank: null,
    });

    const balanceValue = opening_balance_value;

    return (
        <div className={classNames(cls.formBlock)}>
            {!!integrationList.length && (
                <div className={classNames(cls.switcherWrapper)}>
                    <Switcher
                        classes={cls.switcher}
                        title={i18next.t('CompanyBlock.return.Switcher.title')}
                        isActive={isActiveSwitcher}
                        onClick={onSwitcherChange}
                    />
                </div>
            )}
            {isActiveSwitcher && (
                <FormBlock>
                    <div className={classNames(cls.blockWrapper)}>
                        <Select
                            isSmartPosition
                            selected={selectedIntegration || null}
                            onChange={onIntegrationChange}
                            placeholder={i18next.t(
                                'CompanyBlock.return.Select.selectedIntegration.placeholder'
                            )}
                            title={i18next.t(
                                'CompanyBlock.return.Select.selectedIntegration.title'
                            )}
                            isRequired
                            options={integrationList}
                        />
                    </div>
                    <div className={classNames(cls.blockWrapper)}>
                        <SelectIntegration
                            isSmartPosition
                            selected={selectedIntegrationAccount || null}
                            onChange={onIntegrationAccountChange}
                            placeholder={i18next.t(
                                'CompanyBlock.return.SelectIntegration.selectedIntegrationAccount.placeholder'
                            )}
                            title={i18next.t(
                                'CompanyBlock.return.SelectIntegration.selectedIntegrationAccount.title'
                            )}
                            isRequired
                            options={integrationAccountList.list}
                            isLoading={integrationAccountList.isLoading}
                            error={errorsTab.accountInBank}
                        />
                    </div>
                </FormBlock>
            )}

            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Select
                        isSmartPosition
                        selected={selectedLegal || null}
                        onChange={onLegalChange}
                        placeholder={i18next.t(
                            'CompanyBlock.return.Select.selectedLegal.placeholder'
                        )}
                        title={i18next.t('CompanyBlock.return.Select.selectedLegal.title')}
                        isRequired
                        options={legalList}
                        error={errorsTab.legalEntity}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isRequired
                        title={i18next.t('CompanyBlock.return.InputTitle.title')}
                        name="title"
                        value={title}
                        onChange={formHandler}
                        error={errorsTab.title}
                    />
                </div>
            </FormBlock>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isDisabled={isActiveSwitcher}
                        isRequired={false}
                        title={i18next.t('CompanyBlock.return.InputAccount_number.title')}
                        name="account_number"
                        value={account_number}
                        onChange={formHandler}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <Select
                        isSmartPosition
                        selected={selectedCurrency || null}
                        onChange={onCurrencyChange}
                        placeholder={i18next.t(
                            'CompanyBlock.return.Select.selectedCurrency.placeholder'
                        )}
                        title={i18next.t('CompanyBlock.return.Select.selectedCurrency.title')}
                        isRequired
                        options={currentList}
                        error={errorsTab.currency}
                    />
                </div>
            </FormBlock>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isDisabled={isActiveSwitcher}
                        isRequired
                        title={i18next.t('CompanyBlock.return.InputOpening_balance_value.title')}
                        name="opening_balance_value"
                        value={balanceValue}
                        onChange={sumFormHandler}
                        error={errorsTab.accountStartBalance}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <DateInput
                        isDisabled={isActiveSwitcher}
                        title={i18next.t('CompanyBlock.return.DateInput.title')}
                        isRequired={false}
                        date={formState.opening_balance_date}
                        inventoryGuid="inventoryGuid"
                        parameterName="opening_balance_date"
                        newCallback={onDateChange}
                        options={{
                            startDate: formState.opening_balance_date,
                            singleDatePicker: true,
                            showDropdowns: true,
                            autoApply: true,
                        }}
                    />
                </div>
            </FormBlock>
            <Checkbox
                title={i18next.t('CompanyBlock.return.Checkbox.title')}
                isActive={isActiveCheckbox}
                onClick={onCheckboxChange}
                isDisabled={false}
            />
        </div>
    );
};
